import axios from 'axios';
import { message } from 'antd';

const TOKEN_KEY = 'admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const setToken = (token: string) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const request = axios.create({
  // 生产环境同源走 nginx 反代（/api → server）；本地开发通过 package.json proxy 转发
  baseURL: process.env.REACT_APP_API_BASE || '/api',
  timeout: 10000,
});

// 请求拦截器：携带 token
request.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 响应拦截器：统一处理 { code, message, data } 格式
request.interceptors.response.use(
  (res) => {
    const body = res.data;
    if (body.code !== 0) {
      message.error(body.message || '请求失败');
      return Promise.reject(new Error(body.message));
    }
    return body.data;
  },
  (err) => {
    const status = err.response?.status;
    const msg = err.response?.data?.message || err.message || '网络错误';
    if (status === 401) {
      clearToken();
      message.error(msg);
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    } else {
      message.error(msg);
    }
    return Promise.reject(err);
  }
);

export default request;
